import type { Assistant } from "@inrev/assistant";
import type { AssistantConversationId } from "@inrev/common";
import { useFetchAssistantChartData } from "@portal/api/assistant/admin";
import { AdminAssistantChartNotice } from "../AdminAssistantChartNotice";
import { AdminAssistantStoredChart } from "../AdminAssistantStoredChart";
import { AdminAssistantOrgChartView } from "./AdminAssistantOrgChartView";

/** An org chart block: the structure `ask_org_chart` stored, fetched and drawn. */
export const AdminAssistantOrgChart = ({
	chart,
	conversationId,
}: {
	chart: Assistant.Charts.OrgChart;
	conversationId: AssistantConversationId;
}) => {
	const stored = useFetchAssistantChartData(conversationId, chart.chartId);

	return (
		<AdminAssistantStoredChart query={stored} resource="org chart">
			{({ data }) =>
				data.entities.length === 0 ? (
					<AdminAssistantChartNotice>
						No entities were found in these documents.
					</AdminAssistantChartNotice>
				) : (
					<AdminAssistantOrgChartView chart={data} />
				)
			}
		</AdminAssistantStoredChart>
	);
};
